import { useRouter } from 'next/router'
import React from 'react'

import type { TherapistType } from '../types/TherapistStateType'
import { getTranslate } from '../utilities/i18n'
import { getFullName } from '../utilities/name'
import TherapistProfileImage from './profiles/TherapistProfileImage'

type HiddenTherapistsPropsType = {
  therapists: TherapistType[]
}

const HiddenTherapists = ({ therapists }: HiddenTherapistsPropsType) => {
  const { t } = getTranslate()
  const router = useRouter()

  const handleOpenTherapistProfile = (therapistId: number) => {
    router.push('/client/[therapistId]/profile', `/client/${therapistId}/profile`)
  }

  const displayedTherapists = therapists.slice(0, 6)

  if (Array.isArray(displayedTherapists) && displayedTherapists.length > 0) {
    return (
      <div className="hidden-therapist__wrapper">
        <div className="hidden-therapist__text-wrapper">
          <h4 className="hidden-therapist__label">{t('component.hiddenTherapists.title')}</h4>
          <p className="hidden-therapist__info">
            {t('component.hiddenTherapists.subtitle')}{' '}
            <a href={process.env.NEXT_PUBLIC_WORDPRESS_WEB} rel="noreferrer" target="_blank">
              <strong>{t('component.button.login')}</strong>
            </a>
          </p>
        </div>
        <div className="hidden-therapist__card-list row relative overflow-hidden">
          <div className="absolute bottom-[0px] left-[-20px] right-[-20px] top-1/2 z-10 bg-gradient-to-t from-body-bg to-transparent" />
          {displayedTherapists.map(({ titleBefore, titleAfter, therapistId, image, ...therapist }) => {
            const fullName = getFullName({ person: therapist, titleAfter, titleBefore })
            return (
              <div
                key={`${fullName}-${therapistId}`}
                className="col-12 col-md-6 col-lg-4"
                onClick={() => {
                  handleOpenTherapistProfile(therapistId)
                }}
              >
                <div className="hidden-therapist__card">
                  <div className="hidden-therapist__card-image-wrapper">
                    <TherapistProfileImage identifier={fullName} openModal={null} source={image} />
                  </div>
                  <span className="hidden-therapist__card-name">{fullName}</span>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
  return null
}

export default HiddenTherapists
